import { formatPriceByLocale } from '../../../lib/utils';

export function formatMshipPurseAmount(
    amount: number,
    currency: string | undefined,
): string {
    return formatPriceByLocale(amount, currency);
}
